/* Glitz & Pearls — theme.js */
(function () {
  'use strict';

  /* ============================================================
     Mobile Nav
     ============================================================ */
  const mobileNav        = document.getElementById('mobile-nav');
  const mobileNavOpen    = document.getElementById('mobile-nav-open');
  const mobileNavClose   = document.getElementById('mobile-nav-close');
  const mobileNavOverlay = document.getElementById('mobile-nav-overlay');

  function openMobileNav() {
    if (!mobileNav) return;
    mobileNav.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    if (mobileNavOpen) mobileNavOpen.setAttribute('aria-expanded', 'true');
  }
  function closeMobileNav() {
    if (!mobileNav) return;
    mobileNav.classList.remove('is-open');
    document.body.style.overflow = '';
    if (mobileNavOpen) mobileNavOpen.setAttribute('aria-expanded', 'false');
  }

  if (mobileNavOpen)    mobileNavOpen.addEventListener('click', openMobileNav);
  if (mobileNavClose)   mobileNavClose.addEventListener('click', closeMobileNav);
  if (mobileNavOverlay) mobileNavOverlay.addEventListener('click', closeMobileNav);

  /* ============================================================
     Search Modal
     ============================================================ */
  const searchModal = document.getElementById('search-modal');
  const searchOpen  = document.getElementById('search-open');
  const searchClose = document.getElementById('search-modal-close');

  function openSearch() {
    if (!searchModal) return;
    searchModal.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    const input = searchModal.querySelector('input');
    if (input) setTimeout(() => input.focus(), 50);
  }
  function closeSearch() {
    if (!searchModal) return;
    searchModal.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  if (searchOpen) searchOpen.addEventListener('click', openSearch);
  if (searchClose) searchClose.addEventListener('click', closeSearch);
  if (searchModal) {
    searchModal.addEventListener('click', function (e) {
      if (e.target === searchModal) closeSearch();
    });
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      closeSearch();
      closeMobileNav();
    }
  });

  /* ============================================================
     FAQ Accordion
     ============================================================ */
  function initFaq() {
    document.querySelectorAll('.faq-trigger').forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        const item   = trigger.closest('.faq-item');
        const answer = item.querySelector('.faq-answer');
        const icon   = trigger.querySelector('.faq-icon');
        const isOpen = item.classList.contains('is-open');

        // Close all open items
        document.querySelectorAll('.faq-item.is-open').forEach(function (openItem) {
          openItem.classList.remove('is-open');
          openItem.querySelector('.faq-trigger').setAttribute('aria-expanded', 'false');
          const openIcon = openItem.querySelector('.faq-icon');
          if (openIcon) openIcon.textContent = '+';
        });

        // Toggle clicked item
        if (!isOpen) {
          item.classList.add('is-open');
          trigger.setAttribute('aria-expanded', 'true');
          if (icon) icon.textContent = '−';
        }
      });
    });
  }
  initFaq();

  /* ============================================================
     Cart Badge — fetch count on load
     ============================================================ */
  function updateCartBadge(count) {
    const badge = document.getElementById('cart-badge');
    if (!badge) return;
    badge.textContent = count;
    badge.style.display = count > 0 ? 'flex' : 'none';
  }

  function fetchCartCount() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) { updateCartBadge(cart.item_count); })
      .catch(function () {});
  }
  fetchCartCount();

  /* ============================================================
     AJAX Add to Bag
     ============================================================ */
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('.btn-add-to-bag');
    if (!btn) return;
    e.preventDefault();

    const variantId = btn.getAttribute('data-product-id');
    if (!variantId) return;

    const originalText = btn.textContent;
    btn.textContent    = 'Adding…';
    btn.disabled       = true;

    fetch('/cart/add.js', {
      method:  'POST',
      headers: { 'Content-Type': 'application/json' },
      body:    JSON.stringify({ id: variantId, quantity: 1 }),
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        btn.textContent = 'Added!';
        fetchCartCount();
        setTimeout(function () {
          btn.textContent = originalText;
          btn.disabled    = false;
        }, 1500);
      })
      .catch(function () {
        btn.textContent = 'Try again';
        btn.disabled    = false;
      });
  });

  /* ============================================================
     Cart — quantity update & remove
     ============================================================ */
  function updateCart(key, quantity) {
    fetch('/cart/change.js', {
      method:  'POST',
      headers: { 'Content-Type': 'application/json' },
      body:    JSON.stringify({ id: key, quantity: quantity }),
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        updateCartBadge(cart.item_count);
        // Update total displayed on page
        const total = document.getElementById('cart-total');
        if (total) {
          total.textContent = formatMoney(cart.total_price);
        }
        // Remove item row if qty = 0
        if (quantity === 0) {
          location.reload();
        }
      })
      .catch(function () {});
  }

  // Quantity input change
  document.querySelectorAll('.cart-qty-input').forEach(function (input) {
    input.addEventListener('change', function () {
      const key = input.getAttribute('data-cart-item-key');
      const qty = parseInt(input.value, 10);
      if (!isNaN(qty) && qty >= 0) updateCart(key, qty);
    });
  });

  // Remove button
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('.cart-item__remove');
    if (!btn) return;
    const key = btn.getAttribute('data-item-key');
    if (key) updateCart(key, 0);
  });

  /* ============================================================
     Utility: format money (PKR)
     ============================================================ */
  function formatMoney(cents) {
    const amount = (cents / 100).toFixed(0);
    return 'Rs. ' + amount.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  /* ============================================================
     Announcement bar: offset sticky header top
     ============================================================ */
  function adjustStickyHeader() {
    const bar    = document.querySelector('.announcement-bar');
    const header = document.getElementById('site-header');
    if (!bar || !header) return;
    const barHeight = bar.offsetHeight;
    header.style.top = barHeight + 'px';
  }
  adjustStickyHeader();
  window.addEventListener('resize', adjustStickyHeader);

  /* ============================================================
     Product Page — Gallery switcher
     ============================================================ */
  function initProductGallery() {
    const thumbs  = document.querySelectorAll('.thumb-btn');
    const mainImg = document.getElementById('product-main-img');
    if (!thumbs.length || !mainImg) return;

    thumbs.forEach(function (btn) {
      btn.addEventListener('click', function () {
        const src = btn.getAttribute('data-media-src');
        if (src) {
          mainImg.style.opacity = '0.6';
          mainImg.src = src;
          mainImg.onload = function () { mainImg.style.opacity = '1'; };
        }
        thumbs.forEach(function (t) { t.classList.remove('is-active'); });
        btn.classList.add('is-active');
      });
    });
  }
  initProductGallery();

  /* ============================================================
     Product Page — Tab switcher
     ============================================================ */
  function initProductTabs() {
    const tabBtns   = document.querySelectorAll('.tab-btn');
    const tabPanels = document.querySelectorAll('.tab-panel');
    if (!tabBtns.length) return;

    tabBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        const target = btn.getAttribute('data-tab');

        tabBtns.forEach(function (b) {
          b.classList.remove('is-active');
          b.setAttribute('aria-selected', 'false');
        });
        tabPanels.forEach(function (p) { p.classList.remove('is-active'); });

        btn.classList.add('is-active');
        btn.setAttribute('aria-selected', 'true');
        const panel = document.getElementById('tab-' + target);
        if (panel) panel.classList.add('is-active');
      });
    });
  }
  initProductTabs();

  /* ============================================================
     Product Page — Quantity stepper
     ============================================================ */
  function initQtyStepper() {
    const dec   = document.getElementById('qty-dec');
    const inc   = document.getElementById('qty-inc');
    const input = document.getElementById('qty-input');
    if (!dec || !inc || !input) return;

    dec.addEventListener('click', function () {
      const val = parseInt(input.value, 10) || 1;
      if (val > 1) input.value = val - 1;
    });
    inc.addEventListener('click', function () {
      const val = parseInt(input.value, 10) || 1;
      if (val < 99) input.value = val + 1;
    });
  }
  initQtyStepper();

  /* ============================================================
     Product Page — Variant / shape selector
     ============================================================ */
  function initVariantSelector() {
    const shapeBtns   = document.querySelectorAll('.shape-btn');
    const variantInput = document.getElementById('selected-variant-id');
    const priceEl     = document.getElementById('product-price');

    if (!shapeBtns.length || !variantInput) return;

    // Read variant data embedded in the page
    const dataEl = document.querySelector('[id^="product-variants-data"]');
    let variants = [];
    if (dataEl) {
      try { variants = JSON.parse(dataEl.textContent); } catch (e) {}
    }

    // Track selected option values
    var selectedOptions = {};
    shapeBtns.forEach(function (btn) {
      const optName = btn.getAttribute('data-option-name');
      const optVal  = btn.getAttribute('data-option-value');
      if (btn.classList.contains('is-active') && optName) {
        selectedOptions[optName] = optVal;
      }
    });

    shapeBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        const optName = btn.getAttribute('data-option-name');
        const optVal  = btn.getAttribute('data-option-value');

        // Deactivate siblings with same option name
        document.querySelectorAll('.shape-btn[data-option-name="' + optName + '"]').forEach(function (b) {
          b.classList.remove('is-active');
        });
        btn.classList.add('is-active');
        selectedOptions[optName] = optVal;

        // Find matching variant
        if (variants.length) {
          var match = variants.find(function (v) {
            return Object.keys(selectedOptions).every(function (name) {
              return v.options && v.options.indexOf(selectedOptions[name]) > -1;
            });
          }) || variants[0];

          if (match) {
            variantInput.value = match.id;
            if (priceEl) {
              priceEl.textContent = 'Rs. ' + Math.floor(match.price / 100).toLocaleString();
            }

            updateBuyButton(match.available);
          }
        }
      });
    });
  }
  initVariantSelector();

    /* ============================================================
     Product Page — reflect variant availability on buy button
     ============================================================ */
  function updateBuyButton(available) {
    const btn = document.getElementById('add-to-bag-pdp');
    if (!btn) return;
    if (available) {
      btn.disabled = false;
      btn.classList.remove('is-sold-out');
      btn.textContent = 'Add to Bag';
    } else {
      btn.disabled = true;
      btn.classList.add('is-sold-out');
      btn.textContent = 'Sold Out';
    }
  }

  /* ============================================================
     Product Page — Add to Bag (AJAX, PDP button)
     ============================================================ */
  function initPdpAddToBag() {
    const form = document.getElementById('product-form');
    const btn  = document.getElementById('add-to-bag-pdp');
    if (!form || !btn) return;

    form.addEventListener('submit', function (e) {
      e.preventDefault();

      // Guard: never add a sold-out / disabled selection
      if (btn.disabled || btn.classList.contains('is-sold-out')) return;

      const variantId = document.getElementById('selected-variant-id');
      const qty       = document.getElementById('qty-input');
      if (!variantId) return;

      btn.textContent = 'Adding…';
      btn.disabled    = true;

      fetch('/cart/add.js', {
        method:  'POST',
        headers: { 'Content-Type': 'application/json' },
        body:    JSON.stringify({
          id:       parseInt(variantId.value, 10),
          quantity: parseInt(qty ? qty.value : 1, 10) || 1,
        }),
      })
        .then(function (r) {
          return r.json().then(function (data) {
            return { ok: r.ok, data: data };
          });
        })
        .then(function (res) {
          if (!res.ok) {
            // Shopify rejected the add (e.g. out of stock)
            btn.textContent = res.data && res.data.description
              ? 'Sold Out'
              : 'Unavailable';
            btn.classList.add('is-sold-out');
            return;
          }
          btn.textContent = '✓ Added to Bag!';
          btn.classList.add('is-added');
          fetchCartCount();
          setTimeout(function () {
            btn.textContent = 'Add to Bag';
            btn.classList.remove('is-added');
            btn.disabled    = false;
          }, 2000);
        })
        .catch(function () {
          btn.textContent = 'Try again';
          btn.disabled    = false;
        });
    });
  }
  initPdpAddToBag();

  /* ============================================================
     Product Recommendations
     ============================================================ */
  function initProductRecs() {
    const grid = document.getElementById('product-recs-grid');
    if (!grid) return;

    const productId = grid.getAttribute('data-product-id');
    const limit     = grid.getAttribute('data-limit') || 4;
    if (!productId) return;

    fetch('/recommendations/products.json?product_id=' + productId + '&limit=' + limit + '&intent=related')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (!data.products || !data.products.length) return;
        grid.innerHTML = data.products.map(function (p) {
          var img  = p.featured_image
            ? p.featured_image.src.replace(/(\.[a-z]+)(\?|$)/, '_600x600$1$2')
            : '';
          var price = 'Rs. ' + Math.floor(p.price / 100).toLocaleString();
          var badge = p.tags && p.tags.includes('bestsellers')
            ? '<span class="product-card__badge product-card__badge--rose">Best Seller</span>'
            : '';
          return (
            '<div class="product-card">' +
              '<a href="' + p.url + '" class="product-card__link">' +
                '<div class="product-card__image-wrap">' +
                  (img ? '<img src="' + img + '" alt="' + p.title.replace(/"/g, '') + '" loading="lazy">' : '') +
                  badge +
                '</div>' +
                '<div class="product-card__body">' +
                  '<p class="product-card__name">' + p.title + '</p>' +
                  '<div class="product-card__footer">' +
                    '<span class="product-card__price">' + price + '</span>' +
                    '<button class="btn-add-to-bag" data-product-id="' + p.variants[0].id + '">Add to Bag</button>' +
                  '</div>' +
                '</div>' +
              '</a>' +
            '</div>'
          );
        }).join('');
      })
      .catch(function () {
        // Silently fail — noscript fallback link is still visible
      });
  }
  initProductRecs();

})();
